import i18next from "i18next";
import React, { useEffect } from "react";
import Header from "~/assets/js/components/Header";
import Tagline from "~/assets/js/components/Tagline";
import Headline from "~/assets/js/components/Typography/Headline";
import { CategoryProvider, useCategoryContext } from "./CategoryProvider";
import { CategoryProducts, CategoryFilters } from "./sections";
import { viewPage } from "~/assets/js/Api/eventsApi";
import { CartProvider } from "~/assets/js/global/cartContext";

const CategoryPage = () => {
    const { state } = useCategoryContext();
    const categoryName = category?.name?.replace(/&amp;/g, "&") || "";

    useEffect(() => {
        setTimeout(() => viewPage(document.title), 500);
    }, []);

    return (
        <main className="category-page container">
            <Headline className="category-page__heading" size={2}>
                {i18next.t("category.label.title", {
                    categoryName,
                })}
            </Headline>
            {state.isMainDish && (
                <Tagline
                    iconUrl={`${reactConfig.iconPath}/sapling.svg`}
                    label="category.label.tagline"
                    options={{ categoryName }}
                />
            )}
            <CategoryFilters />
            <CategoryProducts />
        </main>
    );
};

const CategoryPageApp = () => {
    return (
        <CartProvider>
            <CategoryProvider>
                <Header />
                <CategoryPage />
            </CategoryProvider>
        </CartProvider>
    );
};

export default CategoryPageApp;
